import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'antd';

/**
 * CopyableValue — reveal a clipped value on hover in a tooltip the user can move
 * into, select and copy (FIN-14012). A native `title` can do neither, which is
 * what 98d225eadcc left the Run Instance Results cells with.
 *
 * antd Tooltip, as FRAML View's Customer ID does (FIN-12889): it stays open while
 * the pointer moves into it, and its text is selectable. Anchored `bottomLeft` so
 * it never covers the table header above the cell — the reason 98d225eadcc
 * dropped the old Popover.
 *
 * Nothing to reveal (empty, whitespace, '-') → the child is returned unwrapped, so
 * hovering a blank cell does not pop an empty box.
 *
 * `children` must forward refs and mouse events (styled components and
 * react-router's Link do).
 */
const CopyableValue = ({ value, children, placement = 'bottomLeft' }) => {
  const text = typeof value === 'string' ? value.trim() : value;
  if (text === undefined || text === null || text === '' || text === '-') {
    return children;
  }
  return (
    <Tooltip
      title={<span className="copyable-value">{String(text)}</span>}
      placement={placement}
      mouseEnterDelay={0.2}
      trigger={['hover', 'focus']}
      overlayInnerStyle={{ userSelect: 'text', wordBreak: 'break-all' }}
      destroyTooltipOnHide>
      {children}
    </Tooltip>
  );
};

CopyableValue.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node.isRequired,
  placement: PropTypes.string
};

export default CopyableValue;
